import { render, staticRenderFns } from "./DesignShopTileSelect.vue?vue&type=template&id=6bcd526c&scoped=true&"
import script from "./DesignShopTileSelect.vue?vue&type=script&lang=js&"
export * from "./DesignShopTileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd526c",
  null
  
)

export default component.exports